import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dbf6505"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "generate-ny-cform"
}
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Generate Trust Compliance Form")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "button-controls" }

export function render(_ctx, _cache) {
  return (_ctx.modalOpened)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "fal fa-times close-icon",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(" Are you sure you want to generate the "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.nextYear), 1),
                      _createTextVNode(" compliance form for "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedPractice.firmName), 1),
                      _createTextVNode("? ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn btn-outline",
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "btn btn-secondary dark",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.confirmModal()), ["prevent"]))
                      }, "Confirm")
                    ])
                  ])
                ])
              ], 512)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}